import React from 'react';
import { Content, Title } from './StrikeZoneExplanationsStyles';

const TopBottom = () => {
  return (
    <div>
      <Title>Top and bottom SZ</Title>
      <Content>
        Is set based on specific and unique values for the top and the bottom of the strike zone per player. If a player does not have a
        dedicated strike zone, a static strike zone will be used.
      </Content>
    </div>
  );
};

export default TopBottom;
